import { configureStore } from '@reduxjs/toolkit';
import pabracesReducer from '../features/pabracesSlice';

export const store = configureStore({
  reducer: {
    pabraces: pabracesReducer,
  },
});
